/**
 * Mirror of students `config/assessment-export.ts` CRM rules for the
 * uni-admin CSV/XLSX surface. Keep in sync with that file.
 *
 * CRM columns are defined for all universities but only exported when the
 * signed-in Cognito group is in {@link CRM_EXPORT_ENABLED_ACRONYMS}.
 */

export const CRM_EXPORT_FIELDS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

export type CrmExportField = (typeof CRM_EXPORT_FIELDS)[number];

/** Cognito group / university acronyms that receive CRM columns. */
export const CRM_EXPORT_ENABLED_ACRONYMS = ["radboud"] as const;

export function isCrmExportEnabled(
  cognitoGroup: string | undefined | null
): boolean {
  if (!cognitoGroup) return false;
  return (CRM_EXPORT_ENABLED_ACRONYMS as readonly string[]).includes(
    cognitoGroup
  );
}

export function crmColumnsFromMeta(
  meta: unknown
): Record<CrmExportField, string> {
  const utm =
    meta && typeof meta === "object" && "utm" in meta
      ? ((meta as { utm?: Record<string, unknown> }).utm ?? {})
      : {};

  return {
    utm_source: String(utm.utm_source ?? ""),
    utm_medium: String(utm.utm_medium ?? ""),
    utm_campaign: String(utm.utm_campaign ?? ""),
    utm_term: String(utm.utm_term ?? ""),
    utm_content: String(utm.utm_content ?? ""),
  };
}

export function isCrmExportColumn(columnName: string): boolean {
  return (CRM_EXPORT_FIELDS as readonly string[]).includes(columnName);
}
